import { IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest } from "../../model/request/xet-tot-nghiep/IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest";
import { apiClient } from "../apiClient";

const DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_ENDPOINT = 'du-dieu-kien-hoc-tap-xet-tot-nghiep';
export const duDieuKienKetQuaHocTapXetTotNghiepApi = {
    SelectByDotXet: (id_dot_xet_tot_nghiep: number) => apiClient.get(`${DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_ENDPOINT}/dot-xet/${id_dot_xet_tot_nghiep}`),
    UpdateLockStatus: (request: IDuDieuKienHocTapXetTotNghiepUpdateLockedRequest) => apiClient.patch(`${DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP_ENDPOINT}/locks`, request),
}